.tool-wrapper{width:100%;height:100%;pointer-events:none}app-tool-inner{pointer-events:auto}
/*# sourceMappingURL=tool.component-L3IGTWI6.css.map */
